import React from 'react';
import { TextFieldWithPrefix, useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { CPDateIcon, EndDateIcon } from 'framework/ui/mui-builder';
import moment from 'moment/moment';

const CurrentlyPlannedDateField = ({
  currentPlannedDateSource,
  completionDateSource,
  rejectionDateSource,
}: {
  currentPlannedDateSource: string;
  completionDateSource: string;
  rejectionDateSource: string;
}) => {
  const { getValue: getCurrentPlannedDate } = useFieldHelper<string>({ source: currentPlannedDateSource });
  const { getValue: getCompletionDate } = useFieldHelper<string>({ source: completionDateSource });
  const { getValue: getRejectionDate } = useFieldHelper<string>({ source: rejectionDateSource });
  const { datesDifference, getToday } = useDateService();

  const currentPlannedDate = getCurrentPlannedDate();
  const completionDate = getCompletionDate();
  const rejectionDate = getRejectionDate();
  const isCompleted = Boolean(completionDate || rejectionDate);

  const isCurrentDatePassed = () => {
    if (!currentPlannedDate) return false;
    return moment(currentPlannedDate).isBefore(getToday(), 'date');
  };

  const getTooltipTitle = () => {
    if (rejectionDate) return 'Rejection date';
    if (completionDate) return 'Completion date';
    return currentPlannedDate ? (
      <div style={{ textAlign: 'center' }}>
        Currently planned date
        <br />
        {moment(currentPlannedDate).format(DATE_FORMAT.API_ONLY_DATE)}
      </div>
    ) : (
      'Currently planned date'
    );
  };

  return (
    <TextFieldWithPrefix
      tooltipProps={{
        title: getTooltipTitle(),
        children: <div>{isCompleted ? <EndDateIcon /> : <CPDateIcon />}</div>,
      }}
      boxSx={{
        color: isCurrentDatePassed() && !isCompleted ? 'error.main' : 'text.primary',
      }}
      label=""
      value={isCompleted ? completionDate || rejectionDate : datesDifference(getToday(), currentPlannedDate)}
    />
  );
};
export default CurrentlyPlannedDateField;
